import { atom } from "jotai";

export const documentosAtom = atom([]);
export const carpetaIdSeleccionadaAtom = atom("");
export const documentoSeleccionadoAtom = atom(undefined);
export const urlDocumentoAtom = atom(undefined);